import React, { memo } from 'react';
const bonuses = [{
  label: '🎁 BONO 1',
  title: 'Kit Cero Pantallas — Plan de 7 Días',
  desc: 'Guía paso a paso para reemplazar el celular por actividades del pack en solo una semana.',
  price: '$12.000'
}, {
  label: '🎁 BONO 2',
  title: 'Actividades para Viaje y Espera',
  desc: '30 fichas compactas para llevar impresas al médico, al auto o a cualquier lugar.',
  price: '$9.000'
}, {
  label: '🎁 BONO 3',
  title: 'Súper Coloreables Premium',
  desc: '40 ilustraciones de alta calidad para colorear: animales, paisajes y mandalas por edad.',
  price: '$10.000'
}, {
  label: '🎁 BONO 4',
  title: 'Stickers y Diplomas de Logros',
  desc: 'Sistema de recompensa visual con stickers imprimibles y diplomas para cada avance.',
  price: '$9.000'
}, {
  label: '🎁 BONO 5',
  title: 'Tijera Feliz — Recortables Pro',
  desc: '25 actividades de recorte por nivel de dificultad para desarrollar motricidad fina.',
  price: '$8.000'
}, {
  label: '🎁 BONO 6',
  title: 'Juegos Listos — Sin Preparación',
  desc: '20 juegos de mesa imprimibles para jugar en familia. Lógica, memoria, letras y números.',
  price: '$10.000'
}];
export function Bonuses() {
  return <section className="w-full bg-white px-4 py-8 text-gray-900 text-base leading-6" style={{
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-44">
      <div className="mx-auto max-w-3xl" data-id="element-45">
        {/* TÍTULO */}
        <div className="mb-4 text-center" data-id="element-46">
          <p className="text-xs font-bold tracking-[2px] uppercase text-orange-500 mb-1" data-id="element-47">
            🎁 Todo esto también es tuyo
          </p>
          <h2 className="text-2xl sm:text-3xl font-black leading-tight text-gray-900 m-0 mb-1" data-id="element-48">
            Más los <span className="text-orange-500" data-id="element-49">6 Bonos Exclusivos</span>
          </h2>
          <p className="text-xs text-gray-500 m-0" data-id="element-50">
            Incluidos en todas las ofertas — sin costo extra
          </p>
        </div>

        {/* BONOS GRID */}
        <div className="mb-5 grid grid-cols-2 lg:grid-cols-3 gap-2.5" data-id="element-51">
          {bonuses.map(bonus => <div key={bonus.label} className="flex flex-col rounded-lg p-3 shadow-sm" style={{
          backgroundColor: 'rgb(255, 247, 237)',
          border: '1px solid rgb(249, 115, 22)'
        }} data-id="element-52">
              {/* LABEL */}
              <div className="mb-1 text-[10px] font-bold uppercase tracking-[1px] text-orange-500" data-id="element-53">
                {bonus.label}
              </div>

              {/* TÍTULO */}
              <h3 className="text-xs sm:text-sm font-black text-gray-900 m-0 mb-1 leading-tight" data-id="element-54">
                {bonus.title}
              </h3>

              {/* DESCRIPCIÓN */}
              <p className="flex-1 text-[11px] leading-snug text-gray-600 m-0 mb-2" data-id="element-55">
                {bonus.desc}
              </p>

              {/* PRECIO TACHADO + GRATIS */}
              <div className="flex items-center gap-1.5" data-id="element-56">
                <span className="text-[11px] text-gray-400 line-through" data-id="element-57">
                  {bonus.price}
                </span>
                <span className="bg-orange-500 text-[9px] font-black text-white rounded-full px-1.5 py-0.5" data-id="element-58">
                  GRATIS
                </span>
              </div>
            </div>)}
        </div>

        {/* VALOR TOTAL DE LOS BONOS */}
        <div className="mx-auto max-w-xl text-center rounded-lg p-3.5 shadow-sm mb-5" style={{
        backgroundColor: 'rgb(255, 247, 237)',
        border: '1px solid rgba(249, 115, 22, 0.4)'
      }} data-id="element-59">
          <p className="text-[10px] font-semibold uppercase tracking-[1.4px] text-orange-500 m-0 mb-0.5" data-id="element-60">
            Valor total de los 6 Bonos
          </p>
          <div className="flex items-center justify-center gap-2" data-id="element-61">
            <span className="text-sm text-gray-400 line-through" data-id="element-62">$58.000</span>
            <span className="text-sm sm:text-base font-black tracking-wide text-orange-500" data-id="element-63">
              🎁 GRATIS — Incluidos siempre
            </span>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center" data-id="element-64">
          <p className="text-xs text-gray-400 mt-1" data-id="element-65">
            🛡️ Garantía 7 días · ⚡ Acceso inmediato · 🔒 Pago seguro
          </p>
        </div>
      </div>
    </section>;
}